export enum TrackingPageCategory {
  HOME = 'home',
  ADP = 'adp',
  ALP = 'alp',
  BASIC = 'basic',
  CATEGORY = 'category',
  CHECKOUT = 'checkout',
  CHECKOUT_WORKSHOP = 'checkout_workshop',
  CONTACT = 'contact',
  CONTACT_FORM = 'contact_form',
  CRDP = 'crdp',
  ALL_ADVICES = 'all_advices',
  EOLP = 'eolp',
  EODP = 'eodp',
  ERROR = 'error',
  INVOICE = 'invoice',
  LOYALTY_CARD = 'loyalty_card',
  FAQ = 'faq',
  MY_ACCOUNT = 'my_account',
  MY_ADDRESSES = 'my_addresses',
  MY_PROFILE = 'my_profile',
  NOTEBOOK = 'notebook',
  NOTEBOOK_DETAILS = 'notebook_details',
  ORDER_DETAIL_PAGE = 'order_detail_page',
  ORDERS_HISTORY = 'orders_history',
  PLP = 'plp',
  PDP = 'pdp',
  REFERRAL = 'referral',
  RESET_PASSWORD = 'reset_password',
  RDP = 'rdp',
  RLP = 'rlp',
  SET_PASSWORD = 'set_password',
  SRE = 'survey_results',
  SRP = 'srp',
  SIGNUP = 'signup',
  SIGNIN = 'signin',
  SURVEY = 'survey',
  THX = 'order_thank_you',
  WISH_LIST = 'wishlist',
}
